module.exports = __webpack_public_path__ + "static/media/hall-AH.c671f303.svg";